import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Auth } from 'aws-amplify';
import { LeftGrid, PrintButtonGrid } from '../../Episode.Styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import {
  EPISODE_ORAS_DCH,
  EPISODE_ORAS_DCH_DELETE_URL,
  formDateFormat
} from '../../../../constants';
import { getStopApi, postStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import { getContactByUser } from '../../../Contact/services/contactsApi';
import FormInputText from '../../../common/Forms/FormTextField';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import moment from 'moment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const Discharge = () => {
	const [user, setUser] = useState(null);
	const [oras, setOras] = useState(null);
	const [successMessage, setSuccessMessage] = useState(false);
	const componentRef = useRef();
  	const handlePrint = useReactToPrint({
    	content: () => componentRef.current,
  	});
  
	const episode = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]
  );
  //console.log('### episode');
  //console.log(episode);

  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail[0]
  );
  //console.log('### participantInfo');
  //console.log(participantInfo);

  const aorcmReferenceData = useSelector((state) => state.aorcmReferenceData);
  //console.log('### aorcmReferenceData');
  //console.log(aorcmReferenceData);

  const [tot1, setTot1] = useState();
  const [tot2, setTot2] = useState();
  const [tot3, setTot3] = useState();
  const [tot4, setTot4] = useState();
  const [tot5, setTot5] = useState();
  const [tot6, setTot6] = useState();
  const [tot7, setTot7] = useState();
  const [totDCH, setTotDCH] = useState();

  const defaultValues = {
    q1_1: '',
    q1_2: '',
    q1_3: '',
    q1_4: '',
    q1_5: '',
    q2_1: '',
    q2_2: '',
    q2_3: '',
    q2_4: '',
    q2_5: '',
    q3_1: '',
    q3_2: '',
    q3_3: '',
    q3_4: '',
    q4_1: '',
    q4_2: '',
    q4_3: '',
    q4_4: '',
    q4_5: '',
    q4_6: '',
    q4_7: '',
    q5_1: '',
    q6_1: '',
    q7_1: '',
    epdOrasAssessDate: null,
    epdOrasCSSID: null
  }

	const { register, watch, handleSubmit, reset, control, formState: { errors } } = useForm({defaultValues: defaultValues});

	React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
    	//console.log(value)
    	setTot1(
    		Number(value.q1_1 ?? 0) + 
    		Number(value.q1_2 ?? 0) + 
    		Number(value.q1_3 ?? 0) + 
    		Number(value.q1_4 ?? 0) + 
    		Number(value.q1_5 ?? 0)
      );
    	setTot2(
    		Number(value.q2_1 ?? 0) + 
    		Number(value.q2_2 ?? 0) + 
    		Number(value.q2_3 ?? 0) + 
    		Number(value.q2_4 ?? 0) + 
    		Number(value.q2_5 ?? 0)
      );
    	setTot3(
    		Number(value.q3_1 ?? 0) + 
    		Number(value.q3_2 ?? 0) + 
    		Number(value.q3_3 ?? 0) + 
    		Number(value.q3_4 ?? 0)
      );
    	setTot4(
    		Number(value.q4_1 ?? 0) + 
    		Number(value.q4_2 ?? 0) + 
    		Number(value.q4_3 ?? 0) +
    		Number(value.q4_4 ?? 0) + 
    		Number(value.q4_5 ?? 0) + 
    		Number(value.q4_6 ?? 0) + 
    		Number(value.q4_7 ?? 0) 
      );
    	setTot5(
    		Number(value.q5_1 ?? 0)
      );
    	setTot6(
    		Number(value.q6_1 ?? 0)
      );
    	setTot7(
    		Number(value.q7_1 ?? 0)
      );
      setTotDCH(
    		Number(value.q1_1 ?? 0) + 
    		Number(value.q1_2 ?? 0) + 
    		Number(value.q1_3 ?? 0) + 
    		Number(value.q1_4 ?? 0) + 
    		Number(value.q1_5 ?? 0) + 
    		Number(value.q2_1 ?? 0) + 
    		Number(value.q2_2 ?? 0) + 
    		Number(value.q2_3 ?? 0) + 
    		Number(value.q2_4 ?? 0) + 
    		Number(value.q2_5 ?? 0) + 
    		Number(value.q3_1 ?? 0) + 
    		Number(value.q3_2 ?? 0) + 
    		Number(value.q3_3 ?? 0) + 
    		Number(value.q3_4 ?? 0) + 
    		Number(value.q4_1 ?? 0) + 
    		Number(value.q4_2 ?? 0) +
    		Number(value.q4_3 ?? 0) +
    		Number(value.q4_4 ?? 0) +
    		Number(value.q4_5 ?? 0) +
    		Number(value.q4_6 ?? 0) +
    		Number(value.q4_7 ?? 0) +
    		Number(value.q5_1 ?? 0) + 
    		Number(value.q6_1 ?? 0) + 
    		Number(value.q7_1 ?? 0)
      );

    });	
     return () => subscription.unsubscribe();
  }, [watch]);

	const onFormSubmit = (payload) => {
		const url = `${EPISODE_ORAS_DCH}`;
  	const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

  	//console.log(payload)
  	payload.EpdID = episode.episodeID;
  	postStopApi({ url, payload, authorization }).then((response) => {
  		fetchData();
  		setSuccessMessage(true)
  	}).catch((e) => alert(e));
	}
	
  const closeSuccessMessage = () => setSuccessMessage(false);

	const onErrors = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

	useEffect(() => {
    const initUser = async () => {
      const userData = await getUser();
      setUser(userData);
    };

    if (!user) {
      initUser();
    } else if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
  }, [user]);

  const fetchData = async () => {
    const commonParams = `${EPISODE_ORAS_DCH}/${episode.episodeId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const response = await getStopApi({ commonParams, authorization });
    if (response?.data) {
     	const oras = {
     									...response.data,
     									epdOrasAssessDate: response.data.epdOrasAssessDate ? moment(response.data.epdOrasAssessDate).format(formDateFormat) : '',

     							 };
     	//console.log('### oras');
     	//console.log(oras);
     	setOras(oras);
     	reset(oras);

    }
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this ORAS Discharge record?')) {
      return;
    }

    const url = `${EPISODE_ORAS_DCH_DELETE_URL}/${oras.epdOrasCSSID}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization })
      .then((response) => {
        console.log('### delete response');
        console.log(response);
        // Clear form and return to add mode
        setOras(null);
        reset(defaultValues);
        setSuccessMessage(true);
      })
      .catch((e) => alert(e));
  };

	return (
  	<>
    	<PrintButtonGrid container>
      	<Grid item>
          	<Box>
          		{user?.contact?.authLock === true && oras?.epdOrasCSSID && (
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Delete
              </Button>
            )}
            &nbsp;
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before printing');		
              			}
              			else {
              				handlePrint();
              			}
              		}}
            	>
              		Print
            	</Button>
          	</Box>
      	</Grid>
    	</PrintButtonGrid>

      <form onSubmit={handleSubmit(onFormSubmit, onErrors)}>
	    	<Box pt={4} px={8} ref={componentRef}>  
		      

        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Box style={{ alignItems: 'center' }}>
              <Typography variant="h4" align="center">
                ORAS Discharge Scoring
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={7}>
            <Typography variant='h5'>Name: {participantInfo.key}</Typography>
          </Grid>
          <LeftGrid item xs={12} sm={5}>
            <Typography variant="h5" align="center">
              Date of Assessment:
            </Typography>

						<FormInputText
              name="epdOrasAssessDate"
              type="date"
              control={control}
              label=""
              register={register('epdOrasAssessDate', { required: "Required" })}
            />
           	<Typography sx={{color: 'red'}}>{errors?.epdOrasAssessDate && errors.epdOrasAssessDate.message}</Typography>

          </LeftGrid>
          <Grid item xs={12} sm={6}>
            <Typography variant='h5'>CDC #: {episode.cDCNumber}</Typography>
          </Grid>
          <LeftGrid item xs={12} sm={6}>
            <Typography sx={{margin: '8px'}} variant="h5" align="center">
              Community Service Specialist:
            </Typography>

            <FormInputDropdown
              name="epdOrasCSSID"
              getIdValue={true}
              control={control}
              options={aorcmReferenceData?.caseManagerOrCMList}
              label=""
              register={register('epdOrasCSSID', { required: "Required" })}
            /> 	
           	<Typography sx={{color: 'red'}}>{errors?.epdOrasCSSID && errors.epdOrasCSSID.message}</Typography>

          
          </LeftGrid>
        </Grid>



		      {/** Family and Social Support **/}
		      <Box pt={0}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650 }} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>1.0 Family and Social Support</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.1 Parents have Criminal Record?

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_1', { required: "Required" })}
					            /> 	

			              	<Typography sx={{color: 'red'}}>{errors?.q1_1 && errors.q1_1.message}</Typography>
			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.2 Satisfied with Current Marital or Equivalent Situation
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q1_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_2 && errors.q1_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.3 Emotional and Personal Support Available from Family or Others

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Very Strong Support'},
					              	{id: 1, value: '1 - None to Strong Support'},
					              ]}
					              label=""
					              register={register('q1_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_3 && errors.q1_3.message}</Typography>
			              	
			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.4 Level of Satisfaction with Current Level of Support from Family or Others

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Very Satisfied'},
					              	{id: 1, value: '1 - Satisfied to No Satisfied'},
					              ]}
					              label=""
					              register={register('q1_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_4 && errors.q1_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.5 Stability of Residence

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q1_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_5 && errors.q1_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Family and Social Support</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot1 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>  

		      {/** Substance Abuse **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>2.0 Substance Abuse</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.1 Age First Began Regularly Using Alcohol
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - 17 or Older'},
					              	{id: 1, value: '1 - Under Age 17'},
					              ]}
					              label=""
					              register={register('q2_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_1 && errors.q2_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.1 Most Recent Period of Abstinence from Alcohol
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Six Months or Longer'},
					              	{id: 1, value: '1 - Less than Six Months'},
					              ]}
					              label=""
					              register={register('q2_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_2 && errors.q2_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.3 Ever Used Illegal Drugs?
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q2_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_3 && errors.q2_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.4 Drug Use Caused Problems
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Past'},
					              	{id: 2, value: '2 - Past'},
					              ]}
					              label=""
					              register={register('q2_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_4 && errors.q2_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.5 Drug Use Caused Problems with Employment
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Past'},
					              	{id: 2, value: '2 - Current'},
					              ]}
					              label=""
					              register={register('q2_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_5 && errors.q2_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Substance Abuse</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot2 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Peer Association **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>3.0 Peer Association</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.1 Criminal Friends
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Some'},
					              	{id: 2, value: '2 - Majority'},
					              ]}
					              label=""
					              register={register('q3_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_1 && errors.q3_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.2 Contact with Past Criminal Peers
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No Contact'},
					              	{id: 1, value: '1 - At Risk'},
					              	{id: 2, value: '2 - Contact or Actively Seeks out Peers'},
					              ]}
					              label=""
					              register={register('q3_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_2 && errors.q3_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.3 Gang Membership
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No, Never'},
					              	{id: 1, value: '1 - Yes, but Not Current'},
					              	{id: 2, value: '2 - Yes, Current'},
					              ]}
					              label=""
					              register={register('q3_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_3 && errors.q3_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.4 Contact with Past Criminal Peers

		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Strong Identification with Prosocial Activities'},
					              	{id: 1, value: '1 - Mixture of Pro- and Antisocial Activities'},
					              	{id: 2, value: '2 - Antisocial Activities'},
					              ]}
					              label=""
					              register={register('q3_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_4 && errors.q3_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Peer Association</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot3 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Criminal Attitudes and Behavioral Patterns **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>4.0 Criminal Attitudes and Behavioral Patterns</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.1 Criminal Attitudes
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No/Limited'},
					              	{id: 1, value: '1 - Some Criminal Attitudes'},
					              	{id: 2, value: '2 - Significant Criminal Attitudes'},
					              ]}
					              label=""
					              register={register('q4_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_1 && errors.q4_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.2 Expresses Concern about Others
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Concerned About Others'},
					              	{id: 1, value: '1 - Concern for Immediate Family/Friends'},
					              	{id: 2, value: '2 - No Concern for Others'},
					              ]}
					              label=""
					              register={register('q4_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_2 && errors.q4_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.3 Feels Lack of Control Over Events
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Controlls Events'},
					              	{id: 1, value: '1 - Sometimes Lacks Controls'},
					              	{id: 2, value: '2 - Generally Lacks Control'},
					              ]}
					              label=""
					              register={register('q4_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_3 && errors.q4_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.4 Telling Lies
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q4_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_4 && errors.q4_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.5 Engages in Risk Taking Behavior
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Rarely Takes Risk'},
					              	{id: 1, value: '1 - Sometimes Takes Risk'},
					              	{id: 2, value: '2 - Generally Takes Risks'},
					              ]}
					              label=""
					              register={register('q4_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_5 && errors.q4_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.6 Walks Away from a Fight
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_6"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - Sometimes'},
					              	{id: 2, value: '2 - Rarely'},
					              ]}
					              label=""
					              register={register('q4_6', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_6 && errors.q4_6.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.7 Believes in "Do Unto Others Before They Do Unto You"
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_7"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Disagree'},
					              	{id: 1, value: '1 - Sometimes'},
					              	{id: 2, value: '2 - Agrees'},
					              ]}
					              label=""
					              register={register('q4_7', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_7 && errors.q4_7.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Criminal Attitudes and Behavioral Patterns</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot4 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Employment **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>5.0 Employment</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	5.1 Currently Employed or Offer Pending
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q5_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q5_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q5_1 && errors.q5_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Employment</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot5 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Social **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>6.0 Social</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	6.1 Linked to Advocate for Social Benefit
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q6_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q6_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q6_1 && errors.q6_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Social</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot6 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Education **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>7.0 Education</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.1 Currently Enrolled in School
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q7_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_1 && errors.q7_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Education</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot7 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Total **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Total Discharge Score</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>{totDCH}</TableCell>
			            </TableRow>
			          </TableHead>
			        </Table>
			      </TableContainer>

			    </Box>      

		    </Box>
		    <LeftGrid pt={4} px={8}>
		    	<Button type='submit' variant="contained">Save Discharge</Button>&nbsp;
            {user?.contact?.authLock === true && oras?.epdOrasCSSID && (
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Delete
              </Button>
            )}
            &nbsp;
		    	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before printing');
              			}
              			else {
              				handlePrint();
              			}
              		}}
            	>
              		Print
            	</Button>
		    </LeftGrid>	  
		  </form>

	    <Snackbar 
	      open={successMessage} 
	      autoHideDuration={3000} 
	      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
	      onClose={closeSuccessMessage}
	    >
	      <Alert 
	  			severity="success"
	        onClose={closeSuccessMessage}
	      >
	      	Save Success!
	      </Alert>
	    </Snackbar>
  
		</>  	
  );	
};

export default Discharge;